import { lenis } from "../plugins/initLenis";

export default function openCloseMenu() {
    let menuIsOpen = false;
    const toggleMenu = document.querySelectorAll('[data-js="toggle-menu"]');
    const menuContainer = document.querySelector('[data-js="menu-slider"]');
    const mainMenu = document.querySelector("#mainMenu");
    const parentItems = mainMenu.querySelectorAll('li.parent');

    let stopScroll = {
        lastScroll: 0,
        noScroll: function () {
            window.scrollTo(0, stopScroll.lastScroll);
        },
    };

    toggleMenu && toggleMenu.forEach(elem => {
        elem.addEventListener('click', (e) => {
            e.preventDefault()
            menuIsOpen ? menuIsOpen = false : menuIsOpen = true;
            if (menuIsOpen) {
                elem.classList.add('is-active')
                menuContainer.classList.add('is-active')
                lenis.stop()
                document.querySelector('main').classList.add('blur-sm');
                document.querySelector('footer').classList.add('blur-sm');
                document.querySelector('#newsLetterSection').classList.add('blur-sm');
                // document.querySelector(".body-header").classList.add("active")
            } else {
                elem.classList.remove('is-active')
                menuContainer.classList.remove('is-active')
                parentItems.forEach((parent) => parent.classList.remove('expanded'))
                document.querySelector('main').classList.remove('blur-sm');
                document.querySelector('footer').classList.remove('blur-sm');
                document.querySelector('#newsLetterSection').classList.remove('blur-sm');
                lenis.start()
                // document.querySelector(".body-header").classList.remove("active")
            }


        })
    })


    parentItems.forEach((parent) => {
        parent.addEventListener('click', function (e) {
            // e.preventDefault()
            this.classList.toggle('expanded');
        })
    })
}